// Session mode persistence helpers (shared between ChatScreen and MainContent)

export const getSessionModesKey = (agentId) => `sessionModes_${agentId || ''}`;
export const getLastUsedModeKey = (agentId) => `lastUsedMode_${agentId || ''}`;

export const loadSessionModes = (agentId) => {
  try {
    const stored = localStorage.getItem(getSessionModesKey(agentId));
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error("Failed to load session modes from localStorage:", error);
    return {};
  }
};

export const loadLastUsedMode = (agentId) => {
  try {
    return localStorage.getItem(getLastUsedModeKey(agentId)) || "deep";
  } catch (error) {
    console.error("Failed to load last used mode from localStorage:", error);
    return "deep";
  }
};

export const saveLastUsedMode = (agentId, mode) => {
  try {
    localStorage.setItem(getLastUsedModeKey(agentId || ''), mode);
  } catch (error) {
    console.error("Failed to save last used mode to localStorage:", error);
  }
};

export const saveSessionMode = (agentId, sessionId, mode) => {
  try {
    if (!agentId || !sessionId) return;
    const modes = loadSessionModes(agentId);
    modes[sessionId] = mode;
    localStorage.setItem(getSessionModesKey(agentId), JSON.stringify(modes));
    localStorage.setItem(getLastUsedModeKey(agentId), mode);
  } catch (error) {
    console.error("Failed to save session mode to localStorage:", error);
  }
};
